module.exports = __webpack_public_path__ + "static/media/local guide.93df4629.png";